<template>
  <div class='col-lg-4 col-md-8 dashboard-item'>
    <div class="card bg">
      <apexchart
        class="apex-charts"
        dir="ltr"
        :series="series"
        :options="chartOptions"
      ></apexchart>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commission-chart',
  props: ['commissionData'],
  data () {
    return {
      monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [{
        name: 'Monthly Commissions',
        data: ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0']
      }],
      chartOptions: {
        chart: {
          width: '100%',
          height: '100%',
          type: 'line',
          toolbar: 'false',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 8,
            opacity: 1
          }
        },
        dataLabels: {
          enabled: false
        },
        colors: ['#FFF'],
        stroke: {
          curve: 'smooth',
          width: 3
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            style: {
              colors: ['#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF']
            }
          }
        },
        yaxis: {
          labels: {
            show: true,
            style: {
              colors: ['#FFF']
            },
            formatter: function (value) {
              return '$' + Number(value).toFixed(0)
            }
          }
        },
        grid: {
          show: false
        }
      }
    }
  },
  methods: {
    updateMonths () {
      const today = new Date()
      const lastMonths = []
      for (let i = 0; i < this.monthNames.length; i++) {
        const commissionMonth = this.monthNames[today.getMonth()]
        const monthAmount = this.commissionData.find(data => data.month === commissionMonth)
        if (monthAmount) {
          this.series[0].data[i] = monthAmount.amount
        }
        lastMonths.push(commissionMonth)
        today.setMonth(today.getMonth() - 1)
      }
      this.chartOptions.xaxis.categories = lastMonths
    }
  },
  created () {
    this.updateMonths()
  }
}
</script>
